import { clsx, type ClassValue } from "clsx";
import { type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type LayoutProps<T = object> = T & {
  children?: ReactNode;
};

export type FileUIPart = {
  type: "file";
  filename?: string;
  mediaType?: string;
  url?: string;
};

const COMPACT_NUMBER_FORMATTER = new Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * withSearchParams returns the current query string with the given keys set,
 * or removed when their value is null. Used to open and close the search-param
 * driven dialogs without dropping unrelated params like assistantId.
 */
export function withSearchParams(
  current: URLSearchParams,
  changes: Record<string, string | null>,
): string {
  const next = new URLSearchParams(current);
  for (const [key, value] of Object.entries(changes)) {
    if (value === null) {
      next.delete(key);
    } else {
      next.set(key, value);
    }
  }
  return next.toString();
}

export function formatCompactNumber(value: number) {
  return COMPACT_NUMBER_FORMATTER.format(value);
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = (reader.result as string).split(",")[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
